import { Component } from '@angular/core';

@Component({
  selector: 'app-redirect-test',
  templateUrl: './redirect-test.component.html',
})
export class RedirectTestComponent {
  ngOnInit(): void {
    window.location.replace(
      'mfm://go?screen=VIDEO_CHAT_ROOT&sessionId=75311c97fd5348eeac5547f98a0c69be&specialistName=Vitalii%20Chernenko',
    );
  }
}
